import { useEffect } from "react";
import brand from "../config/brand.json";
import PAGE_META from "../config/pageMeta.json";
import { useI18n } from "../i18n/I18nContext";
import { PREFIX, stripLang, isPublicPath } from "./langPath";

const OG_LOCALE = { en: "en_IN", hi: "hi_IN", hinglish: "hi_IN" };
const HREFLANG = { en: "en", hi: "hi", hinglish: "hi-Latn" };
export const pageUrl = (base, lang) => (isPublicPath(base) ? `${brand.siteUrl}${base === "/" ? (PREFIX[lang] || "/") : PREFIX[lang] + base}` : `${brand.siteUrl}${base}`);

function setMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setLinks(alts, canonical) {
  document.head.querySelectorAll('link[rel="canonical"], link[rel="alternate"][hreflang]').forEach((n) => n.remove());
  const add = (attrs) => { const l = document.createElement("link"); Object.entries(attrs).forEach(([k, v]) => l.setAttribute(k, v)); document.head.appendChild(l); };
  add({ rel: "canonical", href: canonical });
  alts.forEach(([hl, href]) => add({ rel: "alternate", hreflang: hl, href }));
}

// Keeps title/meta/canonical/hreflang identical to the pre-rendered HTML (scripts/prerender.mjs).
export function useSeo({ title, description, path, noindex = false, langs = ["en", "hi", "hinglish"], type = "website" }) {
  const { lang } = useI18n();
  useEffect(() => {
    const base = stripLang(path ?? window.location.pathname);
    const meta = PAGE_META[base]?.[lang];
    const t = meta?.title || title;
    const full = t ? `${t} | ${brand.name}` : `${brand.name} — ${brand.tagline}`;
    const desc = meta?.description || description || brand.metaDescription;
    const url = pageUrl(base, langs.includes(lang) ? lang : langs[0]);
    document.title = full;
    setMeta("name", "description", desc);
    setMeta("property", "og:title", full);
    setMeta("property", "og:description", desc);
    setMeta("property", "og:type", type);
    setMeta("property", "og:url", url);
    setMeta("property", "og:site_name", brand.name);
    setMeta("property", "og:locale", OG_LOCALE[lang]);
    setMeta("name", "robots", noindex ? "noindex, nofollow" : "index, follow");
    const alts = langs.map((l) => [HREFLANG[l], pageUrl(base, l)]);
    if (langs.includes("en")) alts.push(["x-default", pageUrl(base, "en")]);
    setLinks(noindex ? [] : alts, url);
  }, [title, description, path, noindex, lang, type, langs.join()]); // eslint-disable-line react-hooks/exhaustive-deps
}
